import { IBybButtonVR } from "@Components/game/common/buttons/byb-button/byb-button-vr";
import Icon from "@Components/generic/icon";
import { useReleaseNotes } from "@Context/common/release-notes/release-notes-context";
import { faNewspaper } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Stack } from "@mui/material";
import { useState } from "react";
import VRReleaseNoteDialog from "./vr-release-note-dialog";
import { StyledVRWhatsNewButton } from "./vr-whats-new-button.styled";

interface IVRWhatsNewButton extends IBybButtonVR {
  onClick?: () => void;
}

/**
 * A button that shows "What's New" and opens the release notes dialog. Shows up when there are unseen release notes.
 */
const VRWhatsNewButton = ({ onClick, ...props }: IVRWhatsNewButton) => {
  const { i18n } = useI18n();
  const { hasUnseenNotes, notes } = useReleaseNotes();
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
    if (onClick) onClick();
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (!hasUnseenNotes) {
    return null;
  }

  return (
    <>
      <StyledVRWhatsNewButton onClick={handleClick} startIcon={<Icon icon={faNewspaper} />} {...props}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: "100%", flex: 1 }}>
          {i18n("release-notes.whats-new-count", { count: notes.length })}
        </Stack>
      </StyledVRWhatsNewButton>

      <VRReleaseNoteDialog open={open} releaseNote={notes[0]} onClose={handleClose} />
    </>
  );
};

export default VRWhatsNewButton;
